const SearchBar = () => {
  const isSearchPage = window.location.pathname === '/search'
  const header = document.getElementById('shopify-section-header')

  if ( !header ) {
    console.warn('SearchBar: header not found')
    return
  }

  const navContainer = header.querySelector('.main-header > .navbar')
  const searchContainer = isSearchPage
    ? document.querySelector('.search-results')
    : header.querySelector('#search-desktop')

  const searchButton = navContainer.querySelector('#nav-search')
  const searchInput = searchContainer.querySelector('#SearchInput')

  if ( !searchButton || !searchInput ) {
    console.warn('SearchBar: search elements not found')
    return
  }

  if ( isSearchPage ) {
    searchInput.focus()
  }

  searchButton.addEventListener('click', () => {
    if ( searchButton.classList.contains('show') ) searchInput.focus()
    if ( isSearchPage ) searchInput.focus()
  })
}

export default SearchBar